import { ReactNode } from 'react';

import { Navigate } from 'react-router-dom';

import { Spinner } from '@/components/ui/spinner';
import { useAuth } from '@/hooks/use-auth';

interface ProtectedRouteProps {
  children: ReactNode;
}

/**
 * ProtectedRoute component
 * Redirects to login if not authenticated
 * Shows loading spinner while checking auth status
 */
export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-dvh flex-col items-center justify-center gap-5 sm:gap-4">
        <Spinner />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};
